import ProductDescription from './ProductDescription'

const WheatTortillaProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '008',
  IsBroadband: true,
  Size: '',
}

export default WheatTortillaProduct
